<div class="box-alert">
  <div class="box-alert__container">
    <div class="box-alert__content">
      <mat-icon [svgIcon]="this.icon|translate"></mat-icon>
      <div [innerHTML]="this.body|translate"></div>
    </div>
  </div>
</div>
